// Shared utilities for customer and budget components

export const getDivisionColor = (division) => {
  switch (division) {
    case 'INTERCOM': return 'bg-blue-600';
    case 'RIMCORE': return 'bg-emerald-600';
    case 'TAPES': return 'bg-orange-600';
    case 'ENSHIELD': return 'bg-violet-600';
    case 'FLOID': return 'bg-cyan-600';
    default: return 'bg-zinc-600';
  }
};

export const getDivisionTextColor = (division) => {
  switch (division) {
    case 'INTERCOM': return 'text-blue-600';
    case 'RIMCORE': return 'text-emerald-600';
    case 'TAPES': return 'text-orange-600';
    case 'ENSHIELD': return 'text-violet-600';
    case 'FLOID': return 'text-cyan-600';
    default: return 'text-zinc-600';
  }
};

export const calculateDiff = (thisYear, lastYear) => {
  if (!lastYear || lastYear === 0) return 0;
  return ((thisYear - lastYear) / lastYear) * 100;
};

export const getAccountManagerStats = (amCustomers) => {
  const completed = amCustomers.filter(c => c.status === 'completed' || c.status === 'approved').length;
  const total = amCustomers.length;
  const thisYearTotal = amCustomers.reduce((sum, c) => sum + (c.thisYearTotal || 0), 0);
  const lastYearTotal = amCustomers.reduce((sum, c) => sum + (c.lastYearTotal || 0), 0);
  const diffPercent = lastYearTotal > 0 ? ((thisYearTotal - lastYearTotal) / lastYearTotal) * 100 : 0;
  const allApproved = amCustomers.every(c => c.approved);
  const anyApproved = amCustomers.some(c => c.approved);
  return { completed, total, thisYearTotal, lastYearTotal, diffPercent, allApproved, anyApproved };
};

// Month configuration
export const MONTHS = ['apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec', 'jan', 'feb', 'mar'];
export const MONTH_LABELS = ['Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'];
